import styled from 'styled-components';

const ColorPickerContainer = styled.div`
  position: relative;
`;

export default ColorPickerContainer;
